<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Charges') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="charges-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="charges-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>

      <div class="outer-container pt-0">
        <artisio-table :items="filteredCharges" :enableFrontEndPagination="true"
                       :pagination="pagination" :fields="tableFields" :enable-simple-search="false">

          <!--            <template v-slot:before-search-placeholder>-->
          <!--              <div class="row d-flex justify-content-end pr-2">-->
          <!--                <div class="text-right">-->
          <!--                  <b-button class="pr-0 pb-0" variant="link" @click="onNewCharge">-->
          <!--                    <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>-->
          <!--                    {{ $t('New Charge') }}-->
          <!--                  </b-button>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->

          <template slot="cell(name)" slot-scope="{item: charge}">
            {{ charge.name }}
            <action-buttons :view="false" :remove="false" @editClick="onEditClick(charge)"/>
          </template>

          <template slot="cell(is_active)" slot-scope="{item: charge}">
            <span v-if="charge.is_active" class="badge bg-success text-white">{{ $t('Yes') }}</span>
            <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
          </template>

          <template slot="cell(taxable)" slot-scope="{item: charge}">
            <span v-if="charge.taxable" class="badge bg-success text-white">{{ $t('Yes') }}</span>
            <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
          </template>

          <template slot="cell(is_vat_inclusive)" slot-scope="{item: charge}">
            <span v-if="charge.is_vat_inclusive" class="badge bg-success text-white">{{ $t('Yes') }}</span>
            <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
          </template>

          <template slot="cell(rate)" slot-scope="{item: charge}">
            {{ charge.rate | asPercentage }}
          </template>

          <template slot="cell(amount)" slot-scope="{item: charge}">
            {{ charge.amount | asCurrency }}
          </template>

        </artisio-table>

        <charge-modal/>

      </div>

    </b-tab>

  </ValidationObserver>
</template>

<script>
  import i18n from "@/shared/i18n";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import {createNamespacedHelpers} from "vuex";
  import ActionButtons from "@/core/components/ams-table/ActionButtons";
  import {SOURCE_BRANCH_CHARGES, SOURCE_BRANCH_ITEM_LOCATIONS} from "@/modules/constants";
  import ChargeModal from "@/modules/setup/branch/tabs/charges/ChargeModal";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');
  const {mapState: mapGlobalState} = createNamespacedHelpers('global');

  export default {
    name: "Charges",
    components: {ArtisioTable, ActionButtons, ChargeModal},
    data() {
      return {
        pagination: {
          limit: 5,
          page: 1,
          total: 1,
        }
      };
    },
    computed: {
      ...mapState({
        charges: state => state.charges,
        selectedBranch: state => state.selectedBranch,
      }),
      ...mapGlobalState(['isSalesTaxEnabled']),
      filteredCharges() {
        return this.charges.filter(charge => charge.branch.uuid === this.selectedBranch.uuid)
      },
      tableFields() {
        return [
          {key: 'name', label: i18n.t('Name')},
          {key: 'is_active', label: i18n.t('Active')},
          {key: 'is_vat_inclusive', label: this.isSalesTaxEnabled ? i18n.t('Includes Sales Tax') : i18n.t('VAT Inclusive')},
          {key: 'taxable', label: i18n.t('Taxable')},
          {key: 'rate', label: i18n.t('Rate')},
          {key: 'amount', label: i18n.t('Amount')},
        ]
      },
    },

    methods: {
      ...mapActions(['getCharges', 'showChargesModal']),
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      onEditClick(item) {
        this.showChargesModal({
          object: item,
          source: SOURCE_BRANCH_CHARGES,
        });
      },
      onNewCharge() {
        this.showChargesModal({
          object: {},
          source: SOURCE_BRANCH_ITEM_LOCATIONS
        })
      },

    },
    mounted() {
      this.getCharges();
    }
  }


</script>

<style lang="scss" scoped>

</style>
